import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import { DatePicker, Form, Input, Radio, Select, Space, Spin } from 'antd';
import { OutstandigAmountByCtridAndEffectDate, getFinModificationByModid } from 'services/fincontract';
import React, { useContext, useEffect, useState } from 'react';

import { AuthContext } from 'components/Auth/Auth';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import BankListSelect from 'components/BankListSelect';
import ButtonLink from 'components/theme_components/ButtonLink';
import CIPayerSelect from 'pages/ClientInvoice/CIDetail/components/CIPayerSelect';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IBasket from 'icons/IBasket';
import InputCurrency from 'components/InputCurrency';
import ParListSelect from 'components/ParListSelect';
import dayjs from 'dayjs';
import moment from 'moment';
import { toDatePickerDate } from 'utils/utilsSFS';
import { useQuery } from 'react-query';

type TabAcceptPaymentProps = {
    setVisible: (visible: boolean) => void;
    setmodalVisibleConfirmVisible: (visible: boolean) => void;
    mode: string;
    source: 'encours' | 'contract-detail' | 'demandes';
    dataInput: any;
    form: FormInstance
};

const TabAcceptPayment: React.FC<TabAcceptPaymentProps> = ({
    setVisible,
    setmodalVisibleConfirmVisible,
    mode,
    source,
    dataInput,
    form
}) => {


    const { isInspect } = useContext(AuthContext);
    const showRadioButtons = source !== 'encours';
    const [modalVisibleDelet, setmodalVisibleDelet] = useState(false);

    const [loading, setLoading] = useState(false);

    useEffect(() => {

        console.log('dataInput', dataInput)
        form.setFieldsValue({
            ...dataInput,
            motif: "TOTALREIM",
            event: 'tabSfsAcceptpay',
            targetStatus: "TOTAL",
            effectdate: toDatePickerDate(dataInput.reviewdatetowish),
            reimbursedamount: dataInput.finamount
        });
        // getOutstandigAmount(moment().format('YYYY-MM-DD'))
    }, [mode, dataInput, form]);

    const modid = dataInput?.modid;
    const { data: modDetails, isFetching } = useQuery(
        ['getFinModificationByModid', { modid }],
        () =>
            modid ? getFinModificationByModid({ modid }).then((res) => res.data) : Promise.resolve(null),
        { refetchOnMount: true, enabled: !!modid }
    );
    //console log finmodification by modid
    console.log("dataInput.modid : ", dataInput?.modid)
    console.log("finmodif details : ", modDetails)

    useEffect(() => {
        if (modDetails?.simulParams) {
            const effectDate = modDetails.simulParams.find(
                (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
            )?.newvalue;
            const reimbursedAmount = modDetails.simulParams.find(
                (item) => item.parcode === 'REIMAMNT' && item.partype === 'IN'
            )?.newvalue;
            const bkaccount = modDetails.simulParams.find(
                (item) => item.parcode === 'BANKACCOUNT' && item.partype === 'IN'
            )?.newvalue;
            const motif = modDetails.simulParams.find(
                (item) => item.parcode === 'MOTIF' && item.partype === 'IN'
            )?.newvalue;
            const comment = modDetails.simulParams.find(
                (item) => item.parcode === 'COMMENT' && item.partype === 'IN'
            )?.newvalue;

            form.setFieldsValue({
                effectDate: effectDate ? dayjs(effectDate) : undefined,
                reimbursedAmount: reimbursedAmount,
                BANKACCOUNT: bkaccount,
                MOTIF: motif,
                COMMENT: comment
            });
        }
    }, [modDetails, form]);

    const handleDelete = () => {
        console.log('Delete payment request');
        setVisible(false);
        setmodalVisibleDelet(false)
    };


    return (
        <Form
            form={form}
            layout="vertical"
            className="large-ant-radio-btn no-border-radius ut-wizard-form "
        >
            {showRadioButtons && (
                <FormInput name="motif" className="custom-radio-group " nolabel>
                    <Radio.Group
                        defaultValue="TOTALREIM"
                        buttonStyle="solid"
                        className="w-100"
                        // onChange={(e) => onchange(e.target.value)}
                        value="TOTALREIM"
                    >
                        <Radio.Button
                            value="PARTREIM"
                            className="text-center custom-radio-button"
                            disabled
                        >
                            <GetLabel label='partialpay' />
                        </Radio.Button>
                        <Radio.Button
                            value="TOTALREIM"
                            className="text-center custom-radio-button"
                        >
                            {/* Montant total */}
                            <GetLabel label='totalpayement' />
                        </Radio.Button>
                    </Radio.Group>
                </FormInput>
            )}

            <FormInput
                // label={
                //   mode === 'create'
                //     ? 'Date de prélèvement'
                //     : 'Date de changement de statut'
                // }
                name="effectdate"
                className="mb-4"
                extra="JJ/MM/AAAA"
                rules={[{ required: true }]}
            >
                <DatePicker
                    format="DD/MM/YYYY"
                    className="w-full no-border-radius"
                    placeholder="JJ/MM/AAAA"
                    required
                    disabled
                />
            </FormInput>


            <FormInput name="reimbursedamount" className="mb-4" rules={[{ required: true }]}>
                <InputCurrency className="no-border-radius" disabled currcode={dataInput.currcode} />
            </FormInput>

            <FormInput name="BANKACCOUNT" className="mb-4">
                {/* <Select className="no-border-radius" disabled>
                    <Select.Option value="account1">
                        XXXXXXX - Lorem Ipsum Dolor
                    </Select.Option>
                </Select> */}
                <BankAccountListSelect
                    params={{
                        tpid: dataInput?.tpidclient,
                        allowedBktype: [
                            'INOUT',
                        ],
                    }}
                />
            </FormInput>

            {/* Populate reason select from modDetails.simulParams if available */}
               <FormInput
                name="MOTIF"
                className="mb-4"
                rules={[{ required: true }]}
            >
                <ParListSelect
                    parcode="CTSTATUS"
                    placeholder="Choisir une raison"
                    className="no-border-radius"
                    allowClear
                />
            </FormInput>
                

            <FormInput name="COMMENT" className="mb-6" >
                <Input.TextArea rows={6} className="no-border-radius" />
            </FormInput>

            <div className="d-flex justify-between align-center pt-4">
                <div>
                    {mode === 'modify' && (
                        <ButtonLink
                            className="ut-reset-btn ut-btn-no-border no-box-shadow mr-4 btn-supp "
                            comcode="Suppdemande"
                            icon={<IBasket />}
                            onClick={() => {
                                !isInspect && setmodalVisibleDelet(true);
                            }}

                        />
                    )}
                </div>
                {/* <Space>
          <ButtonLink
            comcode={mode === 'modify' ? 'Fermer' : 'Annuler'}
            onClick={() => setVisible(false)}
            className="btn-light"
          />
          <ButtonLink
            comcode="Valider"
            type="primary"
            onClick={handleSubmit}
            className="no-border-radius"
          />
        </Space> */}
            </div>
            <ConfirmModal
                className="modalConfirmOrCancel"
                visible={modalVisibleDelet}
                status="error"
                message="Etes vous sure de vouloir supprimer ces demandes ?"
                onConfirm={
                    handleDelete
                }
                onCancel={() => {
                    !isInspect && setmodalVisibleDelet(false);
                }}
                Confirmcomcode="valider"
                Cancelcomcode='close'
            />

        </Form>
    );
};

export default TabAcceptPayment;
